var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main d-flex flex-column"},[(_vm.announcements.length > 0)?_c(_vm.setParallels,{tag:"component",staticClass:"flex-grow-1",attrs:{"announcements":_vm.announcements,"isPreview":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }